//https://stackoverflow.com/questions/48514773/use-history-push-in-action-creator-with-react-router-v4
import createBrowserHistory from 'history/createBrowserHistory';
export const history = createBrowserHistory();

export const baseUrl = 'https://backend-production-9425.up.railway.app';
